import { useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";

import { MIN_CONVERSION_AMOUNT } from "constants";
import ConvertCoins from "./ConvertCoins";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import { useNavigate } from "react-router-dom";

export default () => {
  const navigate = useNavigate();

  const [amount, setAmount] = useState("");
  const [conversionLoading, setConversionLoading] = useState(false);
  const [warnings, setWarnings] = useState([]);
  const [conversionError, setConversionError] = useState(null);

  // Fetch data
  const GET_COIN_CONVERSION_DATA = gql`
    query GetCoinConversionData {
      coinCoversionData {
        exchangeRate
        balanceToConvert
      }
    }
  `;

  const { data, error } = useQuery(GET_COIN_CONVERSION_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("fetching coin conversion data error", error);
    captureException(error);
  }

  const onAmountChange = (e) => {
    if (/^\d*$/.test(e.target.value)) {
      let newValue = e.target.value !== "0" ? e.target.value : "";

      setAmount(newValue);
    }
  };

  const CONVERT_COINS = gql`
    mutation ConvertCoins($amount: Int!) {
      convertCoins(amount: $amount) {
        resultCode
      }
    }
  `;

  const [convertCoins] = useMutation(CONVERT_COINS);

  const onConvert = async () => {
    if (!data) return;
    if (conversionLoading) return;

    setConversionError(null);
    setWarnings([]);

    if (amount > data.coinCoversionData.balanceToConvert) {
      setWarnings(["amount"]);
      setConversionError("amountOverBalance");

      return;
    }

    if (amount < MIN_CONVERSION_AMOUNT) {
      setWarnings(["amount"]);
      setConversionError("amountTooSmall");

      return;
    }

    setConversionLoading(true);

    const result = await convertCoins({
      variables: { amount: Number(amount) },
    });

    const { resultCode } = result.data.convertCoins;

    if (resultCode === 6) {
      setConversionError("lowBalance");
    }

    if (resultCode !== 0) {
      setConversionError("conversionError");
    }

    setConversionLoading(false);

    navigate("/wallet");
  };

  //console.log({ data });

  return (
    <ConvertCoins
      data={data}
      warnings={warnings}
      amount={amount}
      onAmountChange={onAmountChange}
      onConvert={onConvert}
      conversionError={conversionError}
      conversionLoading={conversionLoading}
    />
  );
};
